import {
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { MaterialModule } from '../../../shared/material/material.module';
import {
  Profession,
  ProfessionControllerService,
} from '../../../core/generated';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContainerComponent } from '../../../shared/container/container.component';

@Component({
  selector: 'app-admin-profession',
  standalone: true,
  imports: [MaterialModule, ContainerComponent],
  templateUrl: './admin-profession.component.html',
  styleUrl: './admin-profession.component.scss'
})
export class AdminProfessionComponent implements OnInit {
  _snackBar = inject(MatSnackBar);
  cd = inject(ChangeDetectorRef);
  professionService = inject(ProfessionControllerService);

  isLoading = false;
  //profession variables
  professions: Profession[] = [];
  displayedColumnsProfessions: string[] = [
    'id',
    'councilGroup',
    'professionName',
    'specialty',
    'activityArea',
    'active',
    'actions',
  ];

  async ngOnInit() {
    await this.loadProfessions();
  }

  //-----------Gerenciar profissões --------------
  loadProfessions() {
    this.professionService.findAll3().subscribe((professions: Profession[]) => {
      if (professions) {
        this.professions = professions;
      }
    });
  }

  deleteProfession(id: any) {
    this.professionService.deleteById7(id).subscribe(() => {
      this.loadProfessions();
      this._snackBar.open('Profissão excluída com sucesso!', 'Fechar', {
        duration: 5000,
      });
    });
  }

  activeProfession(profession: Profession) {
    if (profession.id) {
      this.professionService
        .update7(profession.id, {
          id: profession.id,
          professionName: profession.professionName,
          specialty: profession.specialty,
          activityArea: profession.activityArea,
          councilGroup: profession.councilGroup,
          active: !profession.active,
        })
        .subscribe(() => {
          this.loadProfessions();
          this._snackBar.open('Status da profissão atualizado com sucesso!', 'Fechar', {
            duration: 5000,
          });
        });
    }
  }
}
